<template>
  <div dir="rtl">
    <div class="background"></div>
    <div class="card absolute main_container">
      <div class="is-flex is-justify-content-space-between login_container">
        <div class="is-flex is-align-items-center is-justify-content-center" style="text-align: center; width: 50%; padding: 30px;">
          <div>
            <p><b><u>Login</u></b></p>
            <div class="is-flex is-align-items-center is-flex-direction-column" style="margin-top: 25px;">
              <input v-model="email" placeholder="אימייל">
              <div class="vertical_space"></div>
              <div class="vertical_space"></div>
              <input v-model="password" type="password" placeholder="סיסמא">
              <div class="vertical_space"></div>
              <div class="vertical_space"></div>
              <div class="vertical_space"></div>
              <div class="is-flex is-justify-content-center">
                <a @click="login" class="button is-info">Submit</a>
              </div>
            </div>
          </div>
        </div>
        <div class="relative logo_container" :style="{ 'background-image': 'url(' + $settings.get({ path: 'background_theme' }) + ')' }" dir="ltr">
          <div class="operation_theme"></div>
          <img :src="$settings.get({ path: 'images' }).logo_bright " width="120px" />
          <div class="separator"></div>
          <p><b>Welcome to {{$settings.get({ path: 'app_name' })}} - Admin Panel</b></p>
          <p>Please type your email and password to login.</p>
          <p class="absolute" style="color: #999; bottom: 25px;">For any problems, please ask for one of the development team members' help.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// libraries
import { mapActions } from 'vuex'

// constants
import { STORE_NAMESPACE } from '@/store/modules/admin_list/types'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    ...mapActions(STORE_NAMESPACE, ['fetchAll']),
    login () {
      this.$network_utils.login({ email: this.email, password: this.password }).then(response => {
        localStorage.setItem('auth', response.auth_token)
        localStorage.removeItem('missionBreakTimes')
        this.$network_utils.getAdminUser({ email: encodeURIComponent(this.email) }).then(response => {
          this.fetchAll().then(() => {
            localStorage.setItem('owner', JSON.stringify(response.resource.admin))
            this.createLoginStat()
            this.$network_utils.updateAdmin({ id: this.$utils.getOwner().id, user_id: this.$utils.getOwner().user_id, is_online: true }).then(() => {
              const general = {
                status: 'active',
                priority: 100,
                owner: this.$utils.getOwner().name,
                minimum_permission: 1,
                maximum_permission: 9
              }
              this.$network_utils.postAlert({
                ...general,
                priority: 101,
                minimum_permission: 0,
                designator: 'morning_routine',
                content: 'שגרת בוקר'
              })
              this.is_logging_out = false
              this.clearLocalStorage()
              this.$router.push({ name: 'login' })
            })
            this.$router.push({ name: 'admin-applicants' })
          })
        })
      }).catch(() => {
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה - הרשאות אינן תקינות' })
      })
    },
    createLoginStat () {
      this.$network_utils.postStat({
        title: 'Recruiter Login',
        designator: 'recruiter_login',
        content: `${this.$utils.getOwner().name} התחבר/ה`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 5,
        resource_id: 1,
        resource_type: 'Admin'
      })
    }
  }
}
</script>
<style scoped>
  .card{
    margin: 0;
  }
  .logo_container {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    width: 50%;
    padding: 30px;
    background-color: var(--color-main);
    color: white;
  }
  img{
    display: block;
  }
  input{
    border: 1px solid var(--color-main);
    color: var(--color-main);
  }
  .operation_theme{
    position: absolute;
    opacity: 0.4;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
  }
  .button{
    background-color: var(--color-button) !important;
    color: var(--color-button-text) !important;
    border-radius: 30px;
  }
  .separator{
    width: 150px;
    border-radius: 30px;
    height: 3px;
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: white;
  }
  .login_container{
    width: 870px;
    height: 510px;
  }
  .main_container{
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .background{
    position: fixed;
    z-index: 0;
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
  }
</style>
